var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.upcomingReleases.length)?_c('p',[_vm._v(_vm._s(_setup.upcomingText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }